export default __webpack_public_path__ + "static/media/Hormone_Img@2x.4cc16bfd.png";